import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, Response } from '@angular/http';
import { FeedColumnLookupService } from './feed-column-lookup.service';
import { HttpUtilityService } from '../../../shared/http-utility.service';
import { EventLoggerService } from '../../../shared/event-logger.service';
import { ErrorManagerService } from '../../../shared/error-handling/error-manager.service';
import { FeedColumnLookup } from './models/feed-column-lookup.model';

@Injectable()
export class FeedColumnLookupServiceImpl implements FeedColumnLookupService {

  constructor(private http: Http, private httpUtility: HttpUtilityService, private eventLogger: EventLoggerService, private errorManager: ErrorManagerService) { }

  get(feedName: string, fieldName: string): Observable<FeedColumnLookup> {
      const headers = this.httpUtility.getHeaders();
      const path = `${feedName}/${fieldName}/values`;
      const url = this.httpUtility.getUrl(path);

      return this.http.get(url, { headers: headers })
          .map((response: Response) => this.processResponse(fieldName, response));
  }

  private processResponse(fieldName: string, response: Response) {
      if (response.status < 200 || response.status >= 300) {
          const error = new Error(response.status + ':' + response.json());
          this.eventLogger.logError(error, 'Error in FeedColumnLookup Service', {});
          if (!this.errorManager.handleError(error, error.name, '', error.message)) {
               Observable.throw(error);
          }
      }

      const feedColumnLookup = new FeedColumnLookup();
      feedColumnLookup.fieldName = fieldName;
      feedColumnLookup.options = response.json();

      return feedColumnLookup;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/shared/feed-column-lookup-impl.service.ts